const { registerLocaleData } = await import('@angular/common');
const { provideHttpClient, withInterceptors } = await import('@angular/common/http');
const { LOCALE_ID, provideAppInitializer, provideZonelessChangeDetection, ErrorHandler } =
  await import('@angular/core');
const { provideRouter, withComponentInputBinding } = await import('@angular/router');
const { authInterceptor, provideAuth, withAppInitializerAuthCheck, OidcSecurityService } =
  await import('angular-auth-oidc-client');

const { routes } = await import('./app.routes');
const { authConfig } = await import('./core/config/auth.config');
const { loadingInterceptor } = await import('./core/interceptors/loading.interceptor');
const { errorInterceptor } = await import('./core/interceptors/error.interceptor');
const { environment } = await import('../environments/environment');
const { MockOidcSecurityService } = await import('./core/mocks/oidc-security.mock');
const { GlobalErrorHandler } = await import('./core/errors/global-error-handler');

const interceptors = [...(environment.bypassAuth ? [] : [authInterceptor()]), loadingInterceptor, errorInterceptor];

const authProviders = environment.bypassAuth
  ? [{ provide: OidcSecurityService, useClass: MockOidcSecurityService }]
  : [provideAuth(authConfig, withAppInitializerAuthCheck())];

export const appConfig: import('@angular/core').ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideHttpClient(withInterceptors(interceptors)),
    provideAppInitializer(async () => {
      const { default: localeDe } = await import('@angular/common/locales/de');
      registerLocaleData(localeDe);
    }),
    ...authProviders,
    { provide: LOCALE_ID, useValue: 'de-DE' },
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
  ],
};
